<template>
  <el-dialog
    left
    title="Parsed Information"
    width="800px"
    :closeOnClickModal="false"
    :closeOnPressEscape="false"
    :showClose="true"
    :visible.sync="showReviewModal"
    @close="handleCancel"
    class="addDocumentsCard"
  >
    <!-- <pre>
  {{parsedFields}}
  </pre> -->
    <div class="row">
      <div class="col-4">
        <div>Document Name: {{ data.name }}</div>
      </div>
      <div class="col-4">
        <div>Document Type: {{ data.document_type }}</div>
      </div>
      <div class="col-4">
        <div>Signed Date: {{ data.date }}</div>
      </div>
    </div>

    <div class="row">
      <div class="col-4" v-for="field in parsedFields" :key="field.key">
        <div>
          <div class="capitalize">{{ field.key }}:</div>
          <input type="text" class="form-control" v-model="field.value" />
        </div>
      </div>
    </div>

    <div class="row" v-if="embedFileUrl && isShowPreview()">
      <embed
        :src="embedFileUrl"
        width="100%"
        height="325px"
        style="margin-top: 20px"
      />
    </div>

    <div
      class="row text-center flex-center"
      v-if="embedFileUrl && !isShowPreview()"
      style="height: 325px; width: 100%"
    >
      Preview is not available for your document.
    </div>

    <div class="col-12 d-flex" style="padding: 0px">
      <div class="col-xl edit-company-action-button-row" style="padding: 0px">
        <button
          type="button"
          class="todo-form-cancel-button btn-outline-secondary"
          @click.prevent="handleCancel"
        >
          Cancel
        </button>
        <button
          type="submit"
          @click.prevent="handleSave"
          class="todo-form-submit-button btn btn-primary"
          style="height: 35px; width: 150px"
          :disabled="showSpinner"
        >
          Save
          <b-spinner
            v-if="showSpinner"
            style="float: right"
            small
            label="Loading..."
          ></b-spinner>
        </button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { Dialog } from "element-ui";
import moment from "moment";
import { Select, Option } from "element-ui";
import api from "../../../axios_api";
//import { Company, patchCompany } from "../../../models/Company";
//import { vals } from "../../../util";
import { mapGetters } from "vuex";
import { vals } from "../../../util";
export default {
  name: "ReviewParsedDocumentCard",
  components: {
    [Dialog.name]: Dialog,
  },
  props: {
    data: Object,
    portfolioItem: Object,
    context: String,
    value: Object,
  },
  data() {
    return {
      vals,
      embedFileUrl: "",
      showSpinner: false,
    };
  },
  computed: {
    ...mapGetters("portfolio", ["portfolioAll"]),
    moment() {
      return moment;
    },
    showReviewModal: {
      get() {
        return this.value.isUpdate;
      },
      set(value) {
        this.value.isUpdate = value;
      },
    },
    parsedFields: {
      get() {
        let fields = [];
        for (let x in this.data.parsed_fields) {
          fields.push({
            key: x,
            value: this.data.parsed_fields[x],
          });
        }
        return fields;
      },
    },
  },
  methods: {
    handleCancel() {
      const self = this;

      self.embedFileUrl = "";
      self.showReviewModal = false;
      this.showSpinner = false;

      self.$emit("refresh", null);
    },
    async handleSave() {
      const self = this;
      self.showSpinner = true;

      let fields = {};

      self.parsedFields.forEach((item) => {
        fields[item.key] = item.value;
      });

      let collection = "file_upload";
      switch (this.context) {
        case "DocumentPage":
          collection = "file_upload";
          break;
        case "FormationDocumentPage":
          collection = "lp_documents";
          break;
      }

      let url = `${self.$route.params.account_id}/${self.$route.params.workspace_id}/parsed-info`;
      await api.put(url, {
        encrypt: {
          data: {
            _id: self.data._id,
            fields,
            collection,
          },
        },
      });

      self.showSpinner = false;
      self.handleCancel();
    },
    async getFilePath(item) {
      let urlData = await api
        .post(`/file/download`, {
          encrypt: {
            data: {
              s3_path: item.s3_path,
              file_type: item.file_type,
            },
          },
        })
        .catch((e) => {
          console.error("error: ", e);
        });

      if (
        urlData &&
        urlData.data &&
        urlData.data.encrypt &&
        urlData.data.encrypt.url
      ) {
        // window.open(urlData.data.encrypt.url);
        this.embedFileUrl = urlData.data.encrypt.url;
      }
    },
    isShowPreview() {
      let file = this.data;

      console.log(JSON.parse(JSON.stringify(file)));

      if (!file) {
        return false;
      }

      if (typeof file == "string") {
        return true;
      }

      if (file.file_type.indexOf("image") != -1) {
        return true;
      }

      if (file.file_type.indexOf("pdf") != -1) {
        return true;
      }

      return false;
    },
  },
  mounted() {
    console.log("mounted");
    this.getFilePath(this.data);
  },
};
</script>

<style>
.capitalize {
  text-transform: capitalize;
}
</style>